import * as React from 'react';
import {connect, Dispatch} from "react-redux";
import CommonStreamItem, {StreamItemAction} from "../../../hiberUiKit/src/molecules/StreamItem/CommonStreamItem";
import LeadFilesAttachedEvent from "../../../model/lead/event/LeadFilesAttachedEvent";
import {fetchLeadEvents} from "../../../store/action/lead/lead";
import {api} from "../../../api/api";
import Toast from "../../helper/Toast";
import {notifyBugsnagAndShowToast} from "../../../utils/Utils";
import RemoveFilesConfirmation from "./RemoveFilesConfirmation";
import TextUtils from "../../../utils/TextUtils";

interface ComponentProps {
	/**
	 * Lead activity to display.
	 */
	activity: LeadFilesAttachedEvent;
}

interface DispatchProps {
	fetchLeadEvents: (leadId: string) => void
}

interface State {
	confirmationVisible: boolean
}

type Props = ComponentProps & DispatchProps;

class LeadFilesAttachedItem extends React.PureComponent<Props, State> {

	constructor(props: Props) {
		super(props);
		this.state = {
			confirmationVisible: false
		};
	}

	render() {
		const activeAttachments = this.props.activity.data.attachments.filter(a => !a.deleted.getOrElse(false));
		return (
			<>
				<CommonStreamItem event={this.props.activity} actions={this.getActions(activeAttachments.length)}/>
				{this.state.confirmationVisible && <RemoveFilesConfirmation attachments={activeAttachments}
																			hideModal={this.hideConfirmationModal}
																			removeFiles={this.removeFiles}/>}
			</>
		)
	}

	hideConfirmationModal = () => this.setState({confirmationVisible: false})

	getActions(activeAttachmentsCount: number): StreamItemAction[] {
		const actions: StreamItemAction[] = [];
		if (activeAttachmentsCount > 0) {
			actions.push(
				new StreamItemAction(TextUtils.addSIfPlural("Remove file", activeAttachmentsCount), this.onRemoveAttachments))
		}
		return actions
	}

	onRemoveAttachments = (evt: React.MouseEvent<HTMLSpanElement>) => {
		evt.stopPropagation();
		this.setState({confirmationVisible: true})
	}

	removeFiles = (ids: string[]) => {
		api.instance.leadApi.removeFiles(this.props.activity.leadId, ids)
			.then(() => {
				this.setState({confirmationVisible: false})
				this.props.fetchLeadEvents(this.props.activity.leadId);
				Toast.success("Files removed", "Remove files");
			}).catch(e => notifyBugsnagAndShowToast(e, "Remove files"))
	}

}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		fetchLeadEvents: (leadId: string) => dispatch(fetchLeadEvents(leadId, () => {}, () => {}))
	}
}

export default connect(null, mapDispatchToProps)(LeadFilesAttachedItem);